export const RICHMENU_DEFAULT_DIVIND = 1.666666666666666666666666666;
